<div class="container-fluid customers-root">
  <app-card-analytics *ngIf="isListPage" [stats]="stats" (shareFilterValue)="onFilterBy($event)"></app-card-analytics>

  <div class="table-root">
    <div class="table-action-wrapper d-flex align-items-center justify-content-between">
      <div id="building_search" class="search-input">
        <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()" />
        <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText"
          (keydown.enter)="search()" (ngModelChange)="this.searchTextUpdate.next($event)" />
      </div>
      <div class="actions-box ml-auto d-flex">
        <div>
          <div class="date-filters d-flex">
            <div id="building_date-type" class="datetype-picker sort-by-root">
              <div class="dropdown date-type-dropdown" (click)="showSelectDateType = !showSelectDateType"
                click-stop-propagation [title]="selectedDateTypeDisplay | translate">
                <span>{{'COMMON.DATE_TYPE.TITLE' | translate}}:</span>
                <span>{{ selectedDateTypeDisplay | translate }}</span>
                <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
              </div>
              <div class="dropdown-opened" *ngIf="showSelectDateType">
                <div [id]="'building_date-type' + (i + 1)" (click)="
                    selectDateType(dateType); (datesValid() == true && (dateTo || dateFrom)) && search()
                  " *ngFor="let dateType of dateTypes; let i = index">
                  <div>{{ dateType.translation | translate }}</div>
                </div>
              </div>
            </div>
            <div id="building_date-from" class="datepicker-container" style="width: 23rem;">
              <label for="dateFrom"> {{'COMMON.FROM' | translate}}: </label>
              <input type="date" id="dateFrom" name="dateFrom" [ngClass]="
                  !datesValid()
                    ? 'btn datepicker-icon-error'
                    : 'btn datepicker-icon'
                " [(ngModel)]="dateFrom" (change)="datesValid() == true && search()" />
            </div>

            <div id="building_date-to" class="datepicker-container">
              <label for="dateTo" class="right-label"> {{'COMMON.TO' | translate}}: </label>
              <input type="date" id="dateTo" name="dateTo" [ngClass]="
                  !datesValid()
                    ? 'btn datepicker-icon-error'
                    : 'btn datepicker-icon'
                " [(ngModel)]="dateTo" (change)="datesValid() == true && search()" />
            </div>
          </div>
        </div>

        <div id="building_sort-by" class="sort-by-root" (click)="showSortBy = !showSortBy" click-stop-propagation>
          <div class="dropdown" [title]="sortByName | translate">
            <span>{{'COMMON.SORT_BY.TITLE' | translate}}:</span>
            <span>{{ sortByName | translate }}</span>
            <span><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
          </div>
          <div class="dropdown-opened" *ngIf="showSortBy">
            <div id="building_sort-by_newest" (click)="sortBy(sortByOptions.NEWEST)">{{'COMMON.SORT_BY.NEWEST' |
              translate}}</div>
            <div id="building_sort-by_slrn-asc" (click)="sortBy(sortByOptions.SLRN_ASC)">{{'COMMON.SORT_BY.SLRN_ASC' |
              translate}}.</div>
            <div id="building_sort-by_slrn-desc" (click)="sortBy(sortByOptions.SLRN_DESC)">{{'COMMON.SORT_BY.SLRN_DESC'
              | translate}}.</div>
          </div>
        </div>

        <div class="d-block poles" *ngIf="permissionsService.isBuildingDownloadAllowed">
          <div class="d-flex align-items-center data clickable nav-item" style="border: 2px solid#00423E"
            (click)="showDownload = !showDownload">
            <span>{{'COMMON.DOWNLOAD' | translate}}</span>
            <div class="ms-auto">
              <img class="arrow-icon" src="../../../assets/icons/dropdown.svg" alt="Arrow Up" />
            </div>
          </div>
          <div *ngIf="showDownload" class="download-options">
            <div class="asset-grouped" [ngClass]="{
                'selected-download': downloadBuilding
              }" (click)="downloadBuilding = true; downlaodInaccessible = false;downloadReplacedMeters=false">
              <span class="asset-name">{{'BUILDINGS.INFO' | translate}}</span>
            </div>
            <div class="asset-grouped" [ngClass]="{
                'selected-download': downlaodInaccessible
              }" (click)="downlaodInaccessible = true; downloadBuilding = false;downloadReplacedMeters=false">
              <span class="asset-name">{{'BUILDINGS.INACCESSIBLE_METERS' | translate}}</span>
            </div>
            <div class="asset-grouped" [ngClass]="{
                'selected-download': downloadReplacedMeters
              }" (click)="downloadBuilding = false; downlaodInaccessible = false;downloadReplacedMeters=true">
              <span class="asset-name">{{'CUSTOMERS.DOWNLOAD.SLRN' | translate}}</span>
            </div>
            <button class="btn btn-primary btn-apply" (click)="download()">
              <span>{{'COMMON.APPLY' | translate}}</span>
            </button>
          </div>
        </div>

        <div *ngIf="permissionsService.isBuildingCreateEditAllowed && isListPage" class="double-action-button">
          <button class="btn btn-primary btn-upload" (click)="showUpload = !showUpload" click-stop-propagation>
            <img src="../../assets/icons/chevron-down.svg" alt="Chevron down" />
          </button>
          <div *ngIf="showUpload" class="xlsx-upload" [routerLink]="'/upload/1/' + utilityId">
            <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" /></div>
            <div>{{'COMMON.UPLOAD_XLSX' | translate}}</div>
          </div>

          <button class="btn btn-primary btn-add-new" routerLink="add"
            *ngIf="permissionsService.isBuildingCreateEditAllowed">
            <img src="../../assets/icons/plus.svg" alt="Plus icon" />
            <span>{{'BUILDINGS.NEW' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="filter">
      <div class="filter-list">
        {{'COMMON.FILTER' | translate}}
        <app-multi-select-dropdown *ngIf="!hasCimDataIntegration" id="building_region_filter" class="multiselect"
          [clicked]="clicked" [items]="regions" [label]="'COMMON.BU.PLURAL'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="selectRegion($event)">
        </app-multi-select-dropdown>
        <app-multi-select-dropdown *ngIf="!hasCimDataIntegration" id="building_area_filter" class="multiselect"
          [clicked]="clicked" [items]="areas" [label]="'COMMON.UT.PLURAL'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="selectArea($event)">
        </app-multi-select-dropdown>
        <app-multi-select-dropdown *ngIf="hasCimDataIntegration" id="building_geo-region_filter" class="multiselect"
          [clicked]="clicked" [items]="geoRegions" [label]="'COMMON.BU.PLURAL'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="selectGeoRegion($event)">
        </app-multi-select-dropdown>
        <app-multi-select-dropdown *ngIf="hasCimDataIntegration" id="building_sub-geo-region_filter" class="multiselect"
          [clicked]="clicked" [items]="subGeoRegions" [label]="'COMMON.UT.PLURAL'" [showMore]="false"
          [requireApply]="true" (shareIndividualCheckedList)="selectSubGeoRegion($event)">
        </app-multi-select-dropdown>

        <select id="building_user-type_filter" name="st-select" (change)="selectUserType($event)" class="form-select">
          <option value="" [selected]="!userType" disabled>
            {{'COMMON.USER.TYPE.TITLE' | translate}}
          </option>
          <option [id]="'building_user-type_filter-' + (i + 1)" [selected]="userType == o.value"
            *ngFor="let o of userTypeOptions; let i = index" value="{{ o.value }}">
            {{ o.translation | translate }}
          </option>
        </select>

        <app-multi-select-dropdown id="building_user_filter" class="multiselect" [searchFilterActive]="true"
          (filterValue)="applySearchFilter($event)" [clicked]="clicked" [items]="filteredUsers"
          [label]="'COMMON.USER.PLURAL'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="selectUsers($event)">
        </app-multi-select-dropdown>
        <app-multi-select-dropdown [id]="'building_validation-status_filter'" *ngIf="permissionsService.isValidationStatusAllowed" class="multiselect" [clicked]="clicked" [items]="statusOptions" [label]="'COMMON.VALIDATION_STATUS'"
          [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectStatus($event)">
        </app-multi-select-dropdown>

        <select id="building_review_status_filter" *ngIf="permissionsService.isReviewStatusAllowed"
          name="review-status-select" (change)="selectReviewStatus($event)" class="form-select">
          <option value="" [selected]="reviewStatus == undefined" disabled>
            {{'COMMON.REVIEW_STATUS' | translate}}
          </option>
          <option [selected]="reviewStatus == s.value" *ngFor="let s of reviewStatusOptions" value="{{ s.value }}">
            {{ s.translation | translate}}
          </option>
        </select>
        <select id="building_tag_filter" name="tag-select" (change)="selectTag($event)" class="form-select">
          <option value="" [selected]="!tag" disabled>{{'COMMON.TAG.TITLE' | translate}}</option>
          <option [id]="'building_tag_filter-' + (i + 1)" [selected]="tag == t.value"
            *ngFor="let t of tagOptions; let i = index" value="{{ t.value }}">
            {{ t.translation | translate }}
          </option>
        </select>
      </div>
      <div *ngIf="selectedFilters.length > 0">
        <app-filter-checklist [filters]="selectedFilters" [useApply]="true" (resetFilterEmitter)="resetFilter($event)"
          (removeFilterEmitter)="removeFilter($event)" (applyFilterEmitter)="applyFilter($event)">
        </app-filter-checklist>
      </div>
      <div *ngIf="buildings">
        <table class="table border-bottom">
          <thead class="table-light">
            <tr>
              <th id="building_table_header_checkbox">
                <input type="checkbox" class="form-check-input" [ngModel]="allCheckboxesChecked"
                  (click)="checkAllCheckboxes()" />
              </th>
              <th id="building_table_header_building-slrn">{{'COMMON.MBC_DETAILS.BUILDING_SLRN' | translate}}</th>
              <th id="building_table_header_address">{{'COMMON.ADDRESS' | translate}}</th>
              <th class="connected-accounts" id="building_table_header_connected-accounts">{{'BUILDINGS.CONNECTED_ACCS'
                | translate}}</th>
              <th id="building_table_header_region">{{'COMMON.BU.SINGLE' | translate}}</th>
              <th id="building_table_header_district">{{'COMMON.UT.SINGLE' | translate}}</th>
              <th *ngIf="!hasCimDataIntegration && permissionsService.isBuildingElectricalAddressCodeAllowed"
                id="building_table_header_el-addr-code">{{ (isCinEnabled ? 'COMMON.MBC_DETAILS.CIN' : 'COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS') | translate }}</th>
              <th *ngIf="isPropertyCodeVisible && permissionsService.isBuildingPropertyCodeAllowed"
                id="building_table_header_prop-code">
                {{'COMMON.MBC_DETAILS.PROPERTY_CODE' | translate}}</th>

              <th id="building_table_header_feeder-name">{{'COMMON.MBC_DETAILS.FEEDER_NAME' | translate}}</th>
              <th id="building_table_header_dt-name">{{'COMMON.DT_NAME' | translate}}</th>
              <th id="building_table_header_validation-status" *ngIf="permissionsService.isValidationStatusAllowed">
                {{'COMMON.VALIDATION_STATUS' | translate}}</th>
              <th class="review-status" id="building_table_header_review-status"
                *ngIf="permissionsService.isReviewStatusAllowed">
                {{'COMMON.REVIEW_STATUS' | translate}}</th>
              <th id="building_table_header_tag">{{'COMMON.TAG.TITLE' | translate}}</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr [id]="'building_table_row-' + (i + 1)" *ngFor="let building of buildings; let i = index">
              <td [id]="'building_table_checkbox' + (i + 1)">
                <input type="checkbox" class="form-check-input" [ngModel]="building.isChecked"
                  (click)="checkBuilding(building.id)" />
              </td>
              <td [id]="'building_table_building-slrn' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building?.slrn | hasValue }}
              </td>
              <td [id]="'building_table_address' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.address | hasValue }}
              </td>
              <td [id]="'building_table_connected-accounts' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.customerCount | number | hasValue }}
              </td>
              <td [id]="'building_table_region' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.region | hasValue }}
              </td>
              <td [id]="'building_table_district' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.area | hasValue }}
              </td>
              <td *ngIf="!hasCimDataIntegration && permissionsService.isBuildingElectricalAddressCodeAllowed"
                [id]="'building_table_el-addr-code-' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.electricalAddressCode | hasValue }}
              </td>
              <td *ngIf="isPropertyCodeVisible && permissionsService.isBuildingPropertyCodeAllowed"
                [id]="'building_table_prop-code-' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.propertyCode | hasValue }}
              </td>
              <td [id]="'building_table_feeder-name' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.feederName | hasValue }}
              </td>
              <td [id]="'building_table_dt-name' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]">
                {{ building.dtName | hasValue }}
              </td>
              <td [id]="'building_table_validation-status' + (i + 1)" (click)="setFilterStorage()"
                [routerLink]="[editRoute, building.id]" *ngIf="permissionsService.isValidationStatusAllowed">
                <div class="building-status" [ngClass]="{
                      'complete-building': building.dataQualityStatus === 'Approved',
                      'rejected-building': building.dataQualityStatus === 'Rejected',
                      'pending-building': building.status === 'Pending' && !building.dataQualityStatus,
                      'assigned-building': (building.status === 'Assigned' || building.status === 'Retagged') && !building.dataQualityStatus
                    }">
                  <ng-container *ngIf="building.dataQualityStatus; else statusBasedOnBuilding">
                    {{ building.dataQualityStatus === 'Approved'
                    ? ('COMMON.ASSET_STATUS.COMPLETE' | translate)
                    : ('COMMON.ASSET_STATUS.REJECTED' | translate) }}
                  </ng-container>
                  <ng-template #statusBasedOnBuilding>
                    <ng-container *ngIf="building.status; else noStatus">
                      {{ 'COMMON.ASSET_STATUS.' + building.status | uppercase | translate }}
                    </ng-container>
                    <ng-template #noStatus>
                      --------
                    </ng-template>
                  </ng-template>
                </div>
              </td>
              <td [id]="'building_table_review_status-' + (i + 1)" *ngIf="permissionsService.isReviewStatusAllowed"
                (click)="setFilterStorage()" [routerLink]="[editRoute, building.id]">
                <div [ngClass]="{ 'green-status': building.isReviewed, 'gray-status': !building.isReviewed }">
                  {{(building.isReviewed ? 'COMMON.REVIEW_STATUS_OPTIONS.REVIEWED' :
                  'COMMON.REVIEW_STATUS_OPTIONS.NOT_REVIEWED') |
                  translate}}
                </div>
              </td>
              <td [id]="'building_table_tag' + (i + 1)">
                <div *ngIf="!building.issueType" class="tag-status">
                  <div (click)="setFilterStorage()" [routerLink]="[editRoute, building.id]" class="tag-new-customer">
                    {{'COMMON.TAG.TAGGED' | translate}}
                  </div>
                </div>
                <div *ngIf="building.issueType" class="tag-status">
                  <div (click)="setFilterStorage()" [routerLink]="[editRoute, building.id]"
                    class="tag-inaccessible-customer">
                    {{'COMMON.BUILDING.TYPE.INACCESSIBLE' | translate}}
                  </div>
                </div>
              </td>
              <td class="td-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-bs-toggle="modal"
                  data-bs-target="#history" (click)="viewAnomaly(building.id)" width="22" height="22">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z" />
                </svg>
              </td>
              <td class="more-icon" (click)="setFilterStorage()" [routerLink]="[editRoute, building.id]">
                <img src="../../assets/icons/more-icon.svg" alt="More icon" class="more-icon" />
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <app-paging *ngIf="count > 0" [pageSize]="pageSize" [count]="count" [currentPage]="currentPage"
            [useDirect]="true" (pageChange)="pageChange($event)"></app-paging>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="history" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered " style="max-width: 1600px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="longTitle">{{'COMMON.HISTORY' | translate}}</h5>
        <button type="button" #closeAnomalyModal class="btn-cancel-modal" data-bs-dismiss="modal">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <div class="container-fluid border-bottom">
        <table>
          <tr class="header-row">
            <th>{{'HISTORY.TIMESTAMP_DATE' | translate}}</th>
            <th>{{'ANOMALY.OPERATOR' | translate}}</th>
            <th>{{'COMMON.ASSET_HISTORIES.SLRNS' | translate}}</th>
            <th>{{'COMMON.ASSET_HISTORIES.FEEDER_NAME' | translate}}</th>
            <th>{{'COMMON.ASSET_HISTORIES.ADDRESSES' | translate}}</th>
            <th>{{'COMMON.ASSET_HISTORIES.DT_NAME' | translate}}</th>
            <th>{{'COMMON.PREVIOUS_CUSTOMERS' | translate}}</th>
            <th>{{'COMMON.TABLE_HEADERS.AREA' | translate}}</th>
            <th>{{'COMMON.BU.SINGLE' | translate}}</th>
          </tr>
          <tr class="content-wrapper" *ngFor="let item of buildingHistory">
            <td>{{ item.lastUpdateTime | date:'short' | hasValue}}</td>
            <td>{{ item.operatorName | hasValue }}</td>
            <td>{{ item.previousBuildingSlrn | historiesHasValue }}</td>
            <td>{{ item.previousFeederName | historiesHasValue}}</td>
            <td>{{ item.previousPhysicalAddress| historiesHasValue }}</td>
            <td>{{ item.previousDtName | historiesHasValue }}</td>
            <td [innerHTML]="item.previousCustomers | historiesHasValue"></td>
            <td>{{ item.areaName | historiesHasValue }}</td>
            <td>{{ item.regionName | historiesHasValue }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
